import React from 'react'
import { Card, Button } from "react-bootstrap"
import { FaMapMarkerAlt, FaHome, FaBuilding } from "react-icons/fa"
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import PropertyAPI from '../../../api/PropertyAPI';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class PropertyTab extends React.Component {
  render() {
    const tab = this.props.activeTab;

    return (
      <div className={`tab-pane fade ${tab === 'property' ? 'show active in' : ''}`}>
        <div className="row">
          <div className="col-md-12">
            <PropertiesSidebar
              {...this.props}
              id={this.props.id}
              type={this.props.type}
              lead={this.props.lead}
              onCount={this.props.onCount}
            />
          </div>
        </div>
      </div>
    );
  }
}


class PropertiesSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.model = reactLocalStorage.getObject(Const.Model).property;

    this.View = Util.isAllow(this.model.permission, Const.PermView);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermInnerListRestrict);

    this.state = {
      inApiCall: true,
      properties: [],
    };
  }

  componentDidMount() {
    this.loadProperties();
  }

  onProperties = () => {
    const lead = this.props.lead;
    const filter = [];

    if (!lead) return filter;

    if (lead.min_budget && lead.max_budget)
      filter.push({
        field: 'price',
        type: 'decimal',
        condition: 'in',
        value: `${lead.min_budget}~${lead.max_budget}`,
      });
    else if (lead.min_budget)
      filter.push({
        field: 'price',
        type: 'decimal',
        condition: 'start-with',
        value: `${lead.min_budget}~`,
      });
    else if (lead.max_budget)
      filter.push({
        field: 'price',
        type: 'decimal',
        condition: 'end-with',
        value: `~${lead.max_budget}`,
      });

    ['property_transaction', 'property_is', 'property_type', 'area'].forEach(
      (key) => {
        if (lead[key]) {
          filter.push({
            field: key,
            type: 'select',
            condition: 'in',
            value: `${lead[key]}`,
          });
        }
      }
    );

    return filter;
  };

  loadProperties = () => {
    const filters = this.onProperties();

    if (!filters.length) {
      this.setState({ inApiCall: false, properties: [] });
      return;
    }

    PropertyAPI.list(
      {
        filters,
        pagination: { currentPage: 1, perPage: 20 },
      },
      this.onReceived,
      this.onFail,
      this.props.logout
    );
  };

  onReceived = (res) => {
    this.props.onCount?.('property', res.count);
    this.setState({ inApiCall: false, properties: res.data });
  };

  onFail = (res) => {
    Util.showError(res?.message || 'Something went wrong');
    this.setState({ inApiCall: false });
  };

  onPreview = (id) => {
    this.props.navigate(`/property/preview/${id}`);
  };

  renderPropertyCard = (property, index) => (
    <Card
      key={index}
      style={{
        backgroundColor: 'white',
        border: '2px solid #e5e7eb',
        borderRadius: '8px',
        overflow: 'hidden',
        marginBottom: '16px',
      }}
    >
      <div style={{ position: 'relative' }}>
        <div
          style={{
            height: '128px',
            backgroundImage: `url(${property?.image || "/images/dummyProperty.jpg"})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div style={{ position: 'absolute', top: 8, right: 8 }}>
          <span
            style={{
              fontSize: 12,
              padding: '4px 8px',
              borderRadius: 999,
              fontWeight: 600,
              background:'#127035',
              color: '#fff',
            }}
          >
            {Display.FieldValue(property, "property_status", this.model.fields)}
          </span>
        </div>
      </div>

      <div style={{ padding: 12 }}>
        <h5 style={{ fontSize: 14, fontWeight: 600 }}>{Display.FieldValue(property, 'name', this.model.fields)}</h5>

        <div className="text-muted small mb-1">
          <FaMapMarkerAlt size={12} /> {Display.FieldValue(property, 'address', this.model.fields)}
        </div>

        <div style={{ fontSize: 18, fontWeight: 700, color: '#2563eb' }}>
          {Display.FieldValue(property, 'price', this.model.fields)}
        </div>

        <div className="d-flex justify-content-between text-muted small mt-2">
          <span>
            <FaHome /> {Display.FieldValue(property, 'property_type', this.model.fields)}
          </span>
          <span>
            <FaBuilding /> {Display.FieldValue(property, 'area', this.model.fields)}
          </span>
        </div>

        {this.View && (
          <Button
            size="sm"
            className="w-100 mt-3"
            style={{ borderRadius: 8 }}
            onClick={() => this.onPreview(property.id)}
          >
            View Details
          </Button>
        )}
      </div>
    </Card>
  );

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <Card
          style={{
            backgroundColor: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            height: '100%',
          }}
        >
          <div
            style={{
              background: 'linear-gradient(to right, #9333ea, #3b82f6)',
              padding: 16,
              color: 'white',
            }}
          >
            <h4 className="mb-0">Matching Properties</h4>
            <small>{this.state.properties.length} properties available</small>
          </div>

          <div style={{ padding: 16, maxHeight: 800, overflowY: 'auto' }}>
            {this.state.properties.length === 0 ? (
              <div className="text-center text-muted">
                No matching properties
              </div>
            ) : (
              this.state.properties.map(this.renderPropertyCard)
            )}
          </div>
        </Card>
      </ApiUiController>
    );
  }
}

export default PropertiesSidebar